import { AxiosResponse } from "axios";
import { GatewayType, getGatewayForApp } from "../../../../../gateways/gatewayRegistry";
import { ClientInfo } from "../types";

export const getClient = async (clientUid: string) => {
  try {
    const token = sessionStorage.getItem("token");
    if (!token) {
      throw new Error("No auth token found");
    }
    const response = await getGatewayForApp(GatewayType.LEGACY).get<AxiosResponse<Partial<ClientInfo>>>(`/clients/${clientUid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};